// extracted by mini-css-extract-plugin
export default {"line":"TitleWithLine_line__8WZ9a","title":"TitleWithLine_title__4wDja"};